<button class="button" [ngClass]="{ primary: color === 'primary', accent: color === 'accent' }" [disabled]="disabled">
  <div class="hoverEffect"></div>
  <ng-content></ng-content>
</button>
